import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, 
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        //启动页
        {
          path: '/',
          redirect: '/home'
        },

        //首页
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        }, 

        //杰出集团
        {
          path: '/aboutgroup',
          name: 'aboutgroup',
          component: resolve => require(['@/view/AboutGroup'], resolve),
          meta: {
            title: title + '-关于集团'
          }
        }, 

        //集团业务 
        {
          path: '/groupbusiness',
          name: 'groupbusiness',
          component: resolve => require(['@/view/GroupBusiness'], resolve),
          meta: {
            title: title + '-集团业务'
          }
        }, 
        
        //杰出资讯
        {
          path: '/groupnews',
          name: 'groupnews',
          component: resolve => require(['@/view/GroupNews'], resolve),
          meta: {
            title: title + '-杰出资讯'
          }
        }, 
        
        {
          path: '/groupnewsdetail',
          name: 'groupnewsdetail',
          component: resolve => require(['@/view/GroupNewsDetail'], resolve),
          meta: {
            title: title + '-资讯详情'
          }
        }, 

        //党群建设
        {
          path: '/partybuilding',
          name: 'partybuilding',
          component: resolve => require(['@/view/PartyBuilding'], resolve),
          meta: {
            title: title + '-党群建设'
          }
        }, 

        //智慧引才
        {
          path: '/wisdomtalents',
          name: 'wisdomtalents',
          component: resolve => require(['@/view/WisdomTalents'], resolve),
          meta: {
            title: title + '-智慧引才'
          }
        },   
        
        //行业研究
        {
          path: '/industryresearch',
          name: 'industryresearch',
          component: resolve => require(['@/view/IndustryResearch'], resolve),
          meta: {
            title: title + '-行业研究'
          }
        }, 

        //遇见杰出
        {
          path: '/meetjiechu',
          name: 'meetjiechu',
          component: resolve => require(['@/view/MeetJiechu'], resolve),
          meta: {
            title: title + '-遇见杰出'
          }
        }, 

        //职位详情
        {
          path: '/jobdetail',
          name: 'jobdetail',
          component: resolve => require(['@/view/JobDetail'], resolve),
          meta: {
            title: title + '-职位详情'
          }
        }, 

        //jet0418 杰出云APP简介
        {
          path: '/aboutJCApp',
          name: 'aboutJCApp',
          component: resolve => require(['@/view/AboutJCApp'], resolve),
          meta: {
            title: title + '-杰出云APP'
          }
        }, 

        //jet0418 杰出云隐私政策
        {
          path: '/privacy',
          name: 'privacy',
          component: resolve => require(['@/view/privacy'], resolve),
          meta: {
            title: title + '-杰出云隐私政策'
          }
        }, 

         //jet0418 杰出云隐私政策
         {
          path: '/agreement',
          name: 'agreement',
          component: resolve => require(['@/view/agreement'], resolve),
          meta: {
            title: title + '-杰出云服务协议'
          }
        }, 

        //*************以下为备用参考，待注释*************
        // {
        //   path: '/software',
        //   name: 'software',
        //   component: resolve => require(['@/view/Software'], resolve),
        //   meta: {
        //     title: title + '-软件产品'
        //   },
        //   children: [
        //     {
        //       path: '/software',
        //       redirect: '/software/smartTown'
        //     },
        //     {
        //       path: '/software/smartTown',
        //       name: 'software',
        //       component: resolve => require(['@/view/Software_smartTown'], resolve),
        //       meta: {
        //         title: '软件产品丨Tessai资管后台'
        //       }
        //     },
        //     {
        //       path: '/software/bigData',
        //       name: 'software',
        //       component: resolve => require(['@/view/Software_bigData'], resolve),
        //       meta: {
        //         title: '软件产品丨Tessai资管客户端'
        //       }
        //     }
        //   ]
        // }, 
        
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js